<script setup lang="ts">
</script>

<template>
  <main>
    <hr />
    <h1>Välkommen till min sida</h1>
    <p>Dena sida gjordes för att sammla alla mina privata prodjekt till en fin terminal</p>
    <p>Servers:      Här hittar man dom olika prodjekt jag hostar kräver dock login för tillfället</p>
    <p>Önskelista:   Som namnet beskriver så är det en sida för att hålla koll på vad jag önskar mig men även för att koordinera med andra och vad dom önskar sig</p>
    <!--<p>Nedladdningar: Här lägger jag upp minärer och konfig filer som jag eller andra kan få lät åtkomst till</p>-->
    <p>Runestone:   En sida för att utforska och interagera med Runestone-projektet vilket är att kunna rendera ut en runsten och runer med SVG och presentera en liten text om mig.</p>
  </main>
</template>
